import {
  getMovementFilesByTicketGroup,
  getMovementFileByTicketGroup,
  getProcessedFileByTicketGroup,
  getProcessedFilesByTicketGroupIds
} from '@/network';
import {
  TICKET_GROUPS_FETCH_TICKET_GROUP,
  TICKET_GROUPS_SET_TICKET_GROUP,
  TICKET_GROUPS_GET_TICKET_GROUP,
  TICKET_GROUPS_SET_LOADING,
  TICKET_GROUPS_SET_ERROR,
  TICKET_GROUPS_GET_LOADING,
  TICKET_GROUPS_GET_ERROR,
  TICKET_GROUPS_CLEAR_ERROR,
  TICKET_GROUPS_FETCH_TICKETS,
  TICKET_GROUPS_SET_TICKETS,
  TICKET_GROUPS_GET_TICKETS,
  TICKET_GROUPS_SET_TICKETS_PAGINATION,
  TICKET_GROUPS_GET_TICKETS_PAGINATION,
  TICKET_GROUPS_FETCH_MOVEMENT_FILES,
  TICKET_GROUPS_FETCH_PROCESSED_FILE,
  TICKET_GROUPS_FETCH_PROCESSED_FILES,
  TICKET_GROUPS_FETCH_MOVEMENT_FILE,
  TICKET_GROUPS_SET_MOVEMENT_FILES,
  TICKET_GROUPS_SET_MOVEMENT_FILE,
  TICKET_GROUPS_SET_PROCESSED_FILE,
  TICKET_GROUPS_GET_MOVEMENT_FILES,
  TICKET_GROUPS_GET_MOVEMENT_FILE,
  TICKET_GROUPS_GET_PROCESSED_FILE
} from './types';
import { ticketGroupService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  ticketGroups: [],
  ticketGroup: {},
  tickets: [],
  ticketsPagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  movementFiles: [],
  fileMovement: {},
  fileMovementProcess: {},
  ...createAsyncState([
    'fetchTicketGroup',
    'fetchTicketGroupTickets',
    'fetchMovementFiles',
    'fetchFileMovement',
    'fetchFileMovementProcess'
  ])
};

const mutations = {
  ...createAsyncMutations(TICKET_GROUPS_SET_LOADING, TICKET_GROUPS_SET_ERROR),
  [TICKET_GROUPS_SET_TICKET_GROUP](state, ticketGroup) {
    state.ticketGroup = ticketGroup;
  },
  [TICKET_GROUPS_SET_TICKETS](state, tickets) {
    state.tickets = tickets;
  },
  [TICKET_GROUPS_SET_TICKETS_PAGINATION](state, pagination) {
    state.pagination = pagination;
  },
  [TICKET_GROUPS_SET_MOVEMENT_FILE](state, payload) {
    state.fileMovement = payload;
  },
  [TICKET_GROUPS_SET_PROCESSED_FILE](state, payload) {
    state.fileMovementProcess = payload;
  },
  [TICKET_GROUPS_SET_MOVEMENT_FILES](state, payload) {
    state.movementFiles = payload;
  }
};

const actions = {
  async [TICKET_GROUPS_FETCH_TICKET_GROUP]({ commit }, ticketGroupId) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchTicketGroup',
      errorMessage: 'Ocurrió un error al obtener el ticket masivo.',
      asyncOperation: async () => {
        let ticketGroup;
        const resp = await ticketGroupService.findOne(ticketGroupId);
        ticketGroup = resp.data;
        commit(TICKET_GROUPS_SET_TICKET_GROUP, ticketGroup);
        return ticketGroup;
      },
      setLoading: TICKET_GROUPS_SET_LOADING,
      setError: TICKET_GROUPS_SET_ERROR
    });
  },

  async [TICKET_GROUPS_FETCH_TICKETS](
    { commit },
    { ticketGroupId, filters, page, size }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchTicketGroupTickets',
      errorMessage:
        'Ocurrió un error al obtener los tickets del ticket masivo.',
      asyncOperation: async () => {
        const hasPagination = size > 0;
        let tickets;

        if (hasPagination) {
          const response = await ticketGroupService.getTicketGroupTickets(
            ticketGroupId,
            {
              ...filters,
              page,
              size
            }
          );
          const { rows, ...pagination } = response.data;
          tickets = rows;
          commit(TICKET_GROUPS_SET_TICKETS_PAGINATION, pagination);
        } else {
          const response = await ticketGroupService.getTicketGroupTickets(
            ticketGroupId,
            filters
          );

          const { rows } = response.data;
          tickets = rows;
        }

        commit(TICKET_GROUPS_SET_TICKETS, tickets);
        return tickets;
      },

      setLoading: TICKET_GROUPS_SET_LOADING,
      setError: TICKET_GROUPS_SET_ERROR
    });
  },

  async [TICKET_GROUPS_FETCH_MOVEMENT_FILES]({ commit }, ticketGroupId) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchMovementFiles',
      errorMessage:
        'Ocurrió un error al obtener los archivos del ticket masivo.',
      asyncOperation: async () => {
        let movementFiles;
        const res = await getMovementFilesByTicketGroup(ticketGroupId);
        movementFiles = res.data;
        commit(TICKET_GROUPS_SET_MOVEMENT_FILES, movementFiles);
        return movementFiles;
      },
      setLoading: TICKET_GROUPS_SET_LOADING,
      setError: TICKET_GROUPS_SET_ERROR
    });
  },

  async [TICKET_GROUPS_FETCH_MOVEMENT_FILE]({ commit }, ticketGroupId) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchFileMovement',
      errorMessage:
        'Ocurrió un error al obtener el archivo cargado al ticket masivo.',
      asyncOperation: async () => {
        let fileMovement;
        const res = await getMovementFileByTicketGroup(ticketGroupId);
        fileMovement = res.data;
        commit(TICKET_GROUPS_SET_MOVEMENT_FILE, fileMovement);
        return fileMovement;
      },
      setLoading: TICKET_GROUPS_SET_LOADING,
      setError: TICKET_GROUPS_SET_ERROR
    });
  },

  async [TICKET_GROUPS_FETCH_PROCESSED_FILE]({ commit }, ticketGroupId) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchFileMovementProcess',
      errorMessage:
        'Ocurrió un error al obtener el archivo procesado del ticket masivo.',
      asyncOperation: async () => {
        let fileMovementProcess;
        const res = await getProcessedFileByTicketGroup(ticketGroupId);
        fileMovementProcess = res.data;
        commit(TICKET_GROUPS_SET_PROCESSED_FILE, fileMovementProcess);
        return fileMovementProcess;
      },
      setLoading: TICKET_GROUPS_SET_LOADING,
      setError: TICKET_GROUPS_SET_ERROR
    });
  },

  async [TICKET_GROUPS_FETCH_PROCESSED_FILES](_, ticketGroupIds) {
    const res = await getProcessedFilesByTicketGroupIds(ticketGroupIds);
    return res.data;
  },

  [TICKET_GROUPS_CLEAR_ERROR]({ commit }, { type }) {
    commit(TICKET_GROUPS_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [TICKET_GROUPS_GET_TICKET_GROUP]: (state) => state.ticketGroup,
  [TICKET_GROUPS_GET_LOADING]: (state) => state.loading,
  [TICKET_GROUPS_GET_ERROR]: (state) => state.error,
  [TICKET_GROUPS_GET_TICKETS]: (state) => state.tickets,
  [TICKET_GROUPS_GET_TICKETS_PAGINATION]: (state) => state.pagination,
  [TICKET_GROUPS_GET_MOVEMENT_FILES]: (state) => state.movementFiles,
  [TICKET_GROUPS_GET_MOVEMENT_FILE]: (state) => state.fileMovement,
  [TICKET_GROUPS_GET_PROCESSED_FILE]: (state) => state.fileMovementProcess
};

export default {
  state,
  mutations,
  actions,
  getters
};
